import { Component, ElementRef, ViewChild, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subscription } from 'rxjs';

import { File } from '@core/objects/file';
import { PreviewRequest} from '@core/objects/preview-request';
import { PreviewsService } from '@core/services/previews/previews.service';

@Component({
    selector: 'core-legacy-notes-pagination',
    templateUrl: './notes-pagination.component.html',
    styleUrls: ['./notes-pagination.component.scss']
})
export class NotesPaginationComponent implements OnInit, OnChanges {

    @Input() file: File;
    @Input() notes: Array<any> = [];
    @Output() onClick = new EventEmitter<any>();

    protected preview$ : Subscription;
    public preview: PreviewRequest = {
        date: "",
        id_file: "",
        total_pages: 0,
        status_code: 0,
        status_text: "PENDING",
        page_properties: []
    };

    public page = 1;
    public noteSelected = null;
    public list: Array<string> = [];

    constructor(private prwSrv: PreviewsService){}

    ngOnInit(){
        this.preview$ = this.prwSrv.getSubscriptor(this.file).subscribe(preview => {
            this.preview = preview;
        });

        this.prwSrv.load(this.file);
    }

    ngOnChanges(changes: SimpleChanges){

        if(changes.notes) {
            this.list = this.notes.map( n => n.text);
        }
    }

    selectPage(event) {
        this.page = event.page;
    }

    onListSelect(index: number) {
        this.noteSelected = { ...this.notes[index]};

        this.selectPage({page: this.noteSelected.page + 1});
    }
}
